import { DatePicker } from '@skbkontur/react-ui';
import { convertDatePickerToISO, convertISOToDatePicker } from '../../helpers/convertDate';
export const getCaption = (begin, end, now) => {
    if (!begin && !end) {
        return 'За всё время';
    }
    if (begin === now && (end === now || !end)) {
        return 'Работают на сегодня';
    }
    if (!begin) {
        return `Работают по ${end}`;
    }
    if (!end) {
        return `Работают с ${begin}`;
    }
    return `Работают ${begin} – ${end}`;
};
export const checkDateInRange = ({ value, message = 'Проверьте правильность введенной даты', type = 'submit', minDate = '01.01.1900', maxDate = '31.12.2099', }) => {
    if (value && !DatePicker.validate(value, { minDate, maxDate })) {
        return { type, message };
    }
    return null;
};
export const validateDateRange = (begin, end) => {
    return (checkDateInRange({ value: begin, maxDate: end || undefined }) === null &&
        checkDateInRange({ value: end, minDate: begin || undefined }) === null);
};
export const convertPeriodToISO = (begin, end) => {
    return {
        begin: begin ? convertDatePickerToISO(begin) : undefined,
        end: end ? convertDatePickerToISO(end) : undefined,
    };
};
export const convertToDatePicker = (ISOstring) => {
    if (!ISOstring) {
        return null;
    }
    return convertISOToDatePicker(ISOstring);
};
